import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c97c212"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = ["src"]

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {

const route = useRoute()
const router = useRouter()
// console.log('playerList', route.params.playerList);
if (!route.params.playerList) {
    console.log('无参数')
    router.push('/')
}

let playerList = JSON.parse(route.params.playerList as string)
let currentPlayer = JSON.parse(route.params.currentPlayer as string)
console.log('playerList', playerList)
const pagePath = ref('wcba-china-reports/' + currentPlayer.playerName + '.html')
const btnTxt = ref('查看下一个球员')
if (currentPlayer.playerName === playerList[playerList.length - 1].playerName) {
    btnTxt.value = '回到首页'
}

onMounted(() => {
    geneIframe()
})

const geneIframe = () => {
    var script = document.createElement('script')
    script.type = 'text/javascript'

    var code = `function audioAutoPlay(){
                var audios = document.getElementsByTagName("video");
                console.log('audios====', audios);
                var play = function(){
                    audios[0].play();
                    audios[0].pause();
                    document.removeEventListener("touchstart",play, false);
                };
                document.addEventListener("touchstart",play, false);
            }
            audioAutoPlay()
            `
    script.appendChild(document.createTextNode(code))
    var ifr = document.getElementById('ifr')!
    var ifrDoc
    ifr.onload = function () {
        ifrDoc = (ifr as HTMLIFrameElement).contentWindow?.document
        var last = ifrDoc?.lastChild
        last!.appendChild(script)
    }
}

const next = () => {
    for (let i = 0; i < playerList.length; i++) {
        const player = playerList[i]
        if (player.playerName === currentPlayer.playerName) {
            if (i < playerList.length - 1) {
                currentPlayer = playerList[i + 1]
                // console.log('currentPlayer===', currentPlayer);

                pagePath.value = 'wcba-china-reports/' + playerList[i + 1].playerName + '.html'
                geneIframe()
                if (i === playerList.length - 2) {
                    btnTxt.value = '回到首页'
                }
                break
            }
            if (i == playerList.length - 1) {
                router.push({
                    name: 'wcba-3v3-player-list',
                })
            }
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", {
        id: "ifr",
        class: "iframe",
        src: pagePath.value,
        frameborder: "0",
        importance: "high"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "next-button",
      onClick: next
    }, _toDisplayString(btnTxt.value), 1)
  ]))
}
}

})